export default __webpack_public_path__ + "static/media/KZ.М.14.2145.68de2ed6.svg";